import { render, staticRenderFns } from "./AgendaTransfer.vue?vue&type=template&id=27a2cb60"
import script from "./AgendaTransfer.vue?vue&type=script&lang=ts"
export * from "./AgendaTransfer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports